// extracted by mini-css-extract-plugin
module.exports = {"container":"BrandTextEntry_container__Fkmei","label":"BrandTextEntry_label__18_DV","entry":"BrandTextEntry_entry__2tImQ","invalid":"BrandTextEntry_invalid__2U7QM"};